<!--
 * @Author: vince
 * @Date: 2021-09-03 14:34:32
 * @LastEditors: vince
 * @LastEditTime: 2021-09-08 10:01:44
 * @Description:
-->
<template>
  <div class="column">
    <div class="state-bar mb-2px">
      <div class="sys-tbh">积分规则列表</div>
      <div class="space"></div>
      <el-button size="small" icon="el-icon-plus" type="primary" @click="onNew"
        >新增</el-button
      >
      <el-button
        v-if="power(userInfo.menuInfoList, 'syncRule')"
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="syncDialog = true"
        >同步规则到</el-button
      >
    </div>
    <div style="flex: 1">
      <el-table
        :loading="loading"
        :data="tableData"
        header-cell-class-name="tbh"
        style="width: 100%"
      >
        <el-table-column
          prop="module"
          label="所属模块"
          align="center"
          :formatter="moduleFormatter"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="功能"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="parentCode"
          label="功能代码"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="classify"
          label="级别"
          align="center"
          :formatter="levelFormatter"
        ></el-table-column>
        <el-table-column
          prop="score"
          label="积分分值"
          align="center"
        ></el-table-column>
        <el-table-column prop="id" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
              <el-button
                slot="reference"
                type="text"
                class="danger"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
        <pagination
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          class="mb-md mr-md"
          slot="append"
          :pageObj="filterForm"
        ></pagination>
      </el-table>
    </div>
    <el-dialog
      title="将学多多积分规则同步到"
      :visible.sync="syncDialog"
      @closed="onSyncDialogClose"
      width="500px"
    >
      <el-form
        v-loading="saving"
        ref="syncForm"
        :model="syncForm"
        :rules="syncRules"
      >
        <el-form-item prop="toSchoolCode">
          <el-select
            style="width: 100%"
            v-model="syncForm.toSchoolCode"
            placeholder="请选择"
          >
            <el-option
              v-for="item in schoolCodeOptions"
              :key="item.schoolCode"
              :label="item.schoolName"
              :value="item.schoolCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="syncDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="onSync" :loading="saving" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="编辑积分规则"
      :visible.sync="dialog"
      @closed="onDialogClose"
    >
      <el-form
        v-loading="saving"
        class="content-box"
        ref="elnewForm"
        :model="newForm"
        :rules="rules"
      >
        <el-form-item label="所属模块" prop="moduleTemp">
          <dic-selector
            dicType="module"
            v-model="newForm.moduleTemp"
          ></dic-selector>
        </el-form-item>
        <el-form-item label="功能" prop="title">
          <el-input
            size="small"
            type="text"
            v-model="newForm.title"
            show-word-limit
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="功能代码" prop="parentCode">
          <el-input
            size="small"
            type="text"
            v-model="newForm.parentCode"
            show-word-limit
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="级别 " prop="classifyTemp">
          <dic-selector
            dicType="level"
            v-model="newForm.classifyTemp"
          ></dic-selector>
        </el-form-item>

        <el-form-item label="分值" prop="score">
          <el-input
            size="small"
            type="number"
            v-model="newForm.score"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="onSave" :loading="saving" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import pagination from '../../components/Pagination.vue'
import dicSelector from '../../components/school/dicSelector.vue'
import { getData, postData, postJson } from '../../http/fetch'
import { power } from '@/utils/index.js'

export default {
  components: {
    pagination,
    dicSelector
  },
  data() {
    return {
      saving: false,
      dialog: false,
      loading: false,
      filterForm: {
        current: 1,
        size: 10,
        total: 0,
        sizeList: [5, 10, 15, 20]
      },
      moduleList: [],
      classifyList: [],
      tableData: [],
      newForm: {
        classify: null,
        id: null,
        infoCode: null,
        module: null,
        parentCode: null,
        schoolCode: null,
        score: 0,
        title: null,
        moduleTemp: null
      },
      rules: {
        // classifyTemp: [
        // 	{ required: true, message: "请选择级别", trigger: "change" }
        // ],
        moduleTemp: [
          { required: true, message: '请选择节点模块', trigger: 'change' }
        ],
        parentCode: [
          { required: true, message: '请输入功能代码', trigger: 'change' }
        ],
        score: [{ required: true, message: '请输入分值', trigger: 'blur' }],
        title: [{ required: true, message: '请输入功能', trigger: 'blur' }]
      },
      syncRules: {
        toSchoolCode: [
          { required: true, message: '请选择学校', trigger: 'change' }
        ]
      },
      syncDialog: false,
      syncForm: {
        toSchoolCode: null
      },
      schoolCodeOptions: []
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['schoolCode', 'operatorId', 'schoolCodes'])
  },
  created() {
    this.getDic('module').then((res) => {
      this.moduleList = res
    })
    this.getDic('level').then((res) => {
      this.classifyList = res
    })
  },
  mounted() {
    this.getList()
    this.getOption()
  },
  methods: {
    power,
    getOption() {
      getData('/teacherScoreInfo/getScoreSchoolList').then((res) => {
        this.schoolCodeOptions = res
      })
    },
    onSyncDialogClose() {
      this.$refs.syncForm.resetFields()
      this.syncForm = {
        toSchoolCode: null
      }
    },
    onSync() {
      this.$refs.syncForm.validate((valid) => {
        if (valid) {
          this.saving = true
          postData('teacherScoreInfo/copySysScoreInfo', {
            toSchoolCode: this.syncForm.toSchoolCode,
            fromSchoolCode: 'xueduoduo',
            operatorId: this.operatorId
          })
            .then((res) => {
              this.syncDialog = false
              this.$message.success('保存成功！')
              this.getList()
              this.syncDialog = false
            })
            .finally(() => {
              this.syncDialog = false
            })
        }
      })
    },
    levelFormatter(row, column, cellValue, index) {
      let result = cellValue
      let find = this.classifyList.find((f) => f.dicCode == cellValue)
      if (find) {
        result = find.dicName
      }
      return result
    },
    moduleFormatter(row, column, cellValue, index) {
      let result = cellValue
      let find = this.moduleList.find((f) => f.dicCode == cellValue)
      if (find) {
        result = find.dicName
      }
      return result
    },
    getDic(dicType) {
      return new Promise((resolve, reject) => {
        getData('/core/dic/getDictionaryList-page', {
          dicType: dicType,
          pageNum: 1,
          pageSize: -1
        }).then((res) => {
          if (res.length > 0) {
            res = res.map((m) => {
              return {
                dicCode: m.dicCode,
                dicName: m.dicName
              }
            })
            resolve(res)
          } else {
            reject()
          }
        })
      })
    },
    getList() {
      this.loading = true
      postJson('/teacherScoreInfo/getSysScoreInfoList', {
        pageSize: this.filterForm.size,
        pageNum: this.filterForm.current,
        schoolCodes: this.schoolCodes
      })
        .then((res) => {
          this.tableData = res.records
          this.filterForm.total = res.total
        })
        .catch()
        .finally(() => {
          this.loading = false
        })
    },
    onNew() {
      this.dialog = true
    },
    onDel(row) {
      this.loading = true
      postData('/teacherScoreInfo/deleteSysScoreInfo', {
        operatorId: this.operatorId,
        id: row.id
      })
        .then((res) => {
          this.$message.success('删除成功！')
          this.getList()
        })
        .finally(() => {
          this.loading = false
        })
    },
    onEdit(row) {
      this.newForm.classify = row.classify
      if (row.classify) {
        this.newForm.classifyTemp = { dicCode: row.classify }
      }

      this.newForm.id = row.id
      this.newForm.infoCode = row.infoCode
      this.newForm.module = row.module
      this.newForm.moduleTemp = {
        dicCode: row.module
      }
      this.newForm.parentCode = row.parentCode
      this.newForm.score = row.score
      this.newForm.title = row.title
      this.dialog = true
    },
    onSave() {
      this.$refs.elnewForm.validate((valid) => {
        if (valid) {
          this.saving = true
          postJson('/teacherScoreInfo/saveOrUpdateSysScoreInfo', {
            classify: this.newForm.classifyTemp?.dicCode || '',
            id: this.newForm.id ? this.newForm.id : null,
            infoCode: this.newForm.infoCode ? this.newForm.infoCode : null,
            module: this.newForm.moduleTemp.dicCode,
            operatorId: this.operatorId,
            parentCode: this.newForm.parentCode,
            schoolCode: this.schoolCode,
            score: this.newForm.score,
            title: this.newForm.title
          })
            .then((res) => {
              this.saving = false
              this.$message.success('保存成功！')
              this.getList()
              this.dialog = false
            })
            .catch()
            .finally(() => {
              this.saving = false
            })
        }
      })
    },
    onDialogClose() {
      this.$refs.elnewForm.resetFields()
      this.newForm = {
        classify: null,
        id: null,
        infoCode: null,
        module: null,
        parentCode: null,
        schoolCode: null,
        score: 0,
        title: null,
        moduleTemp: null
      }
      console.log('this.$refs.elnewForm', this.newForm)
    }, //分页
    handleSizeChange(pageSize) {
      this.filterForm.current = 1
      this.filterForm.size = pageSize
      this.getList()
    },
    handleCurrentChange(curPage) {
      this.filterForm.current = curPage
      this.getList()
    }
  }
}
</script>

<style>
</style>
